import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobeIcon, SearchIcon, UserIcon, MessageIcon } from './Icons';
import { triggerHaptic } from '../Utils/miniApp';

export default function MiniAppTabBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname;

  const handleTab = (path) => {
    triggerHaptic('light');
    navigate(path);
  };

  const isHome = currentPath === '/';
  const isWhois = currentPath === '/whois' || currentPath === '/whois.html' || currentPath === '/search' || currentPath === '/search.html';
  const isCabinet = currentPath.startsWith('/cabinet');
  const isContact = currentPath === '/contact.html' || currentPath === '/contact';

  return (
    <nav 
      aria-label="Mini App Navigation"
      className="fixed bottom-0 left-0 right-0 z-50 bg-dark-100/90 backdrop-blur-xl border-t border-white/10 px-4 py-2 safe-area-bottom shadow-2xl"
    >
      <div className="max-w-md mx-auto grid grid-cols-4 gap-1">
        <button
          onClick={() => handleTab('/')}
          className={`flex flex-col items-center justify-center py-1.5 px-2 rounded-xl transition-all ${
            isHome 
              ? 'text-primary-400 font-semibold bg-primary-500/10' 
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <GlobeIcon className={`w-5 h-5 mb-1 transition-transform ${isHome ? 'scale-110 text-primary-400' : ''}`} />
          <span className="text-[11px] tracking-tight">Market</span>
        </button>

        <button
          onClick={() => handleTab('/whois')}
          className={`flex flex-col items-center justify-center py-1.5 px-2 rounded-xl transition-all ${
            isWhois 
              ? 'text-primary-400 font-semibold bg-primary-500/10' 
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <SearchIcon className={`w-5 h-5 mb-1 transition-transform ${isWhois ? 'scale-110 text-primary-400' : ''}`} />
          <span className="text-[11px] tracking-tight">WHOIS</span>
        </button>

        <button
          onClick={() => handleTab('/cabinet')}
          className={`flex flex-col items-center justify-center py-1.5 px-2 rounded-xl transition-all ${
            isCabinet 
              ? 'text-primary-400 font-semibold bg-primary-500/10' 
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <UserIcon className={`w-5 h-5 mb-1 transition-transform ${isCabinet ? 'scale-110 text-primary-400' : ''}`} />
          <span className="text-[11px] tracking-tight">Cabinet</span>
        </button>

        <button
          onClick={() => handleTab('/contact.html')}
          className={`flex flex-col items-center justify-center py-1.5 px-2 rounded-xl transition-all ${
            isContact 
              ? 'text-primary-400 font-semibold bg-primary-500/10' 
              : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <MessageIcon className={`w-5 h-5 mb-1 transition-transform ${isContact ? 'scale-110 text-primary-400' : ''}`} />
          <span className="text-[11px] tracking-tight">Contact</span>
        </button>
      </div>
    </nav>
  );
}
